export default {"src":"/_next/static/image/src/components/BillingInformationForm/mastercard.c260099e5e2b57c5ac500bd2b8ab10f3.svg","height":24,"width":34};